import { render, staticRenderFns } from "./AlignVertical.vue?vue&type=template&id=32b7b29b&scoped=true"
import script from "./AlignVertical.vue?vue&type=script&lang=js"
export * from "./AlignVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7b29b",
  null
  
)

export default component.exports